// extracted by mini-css-extract-plugin
export default {"searchDoctors":"DoctorsInBranch_searchDoctors__KrhwR","results":"DoctorsInBranch_results__bUcJj","expend":"DoctorsInBranch_expend__8DHvX","show":"DoctorsInBranch_show__ZVY4U"};